import CrewVaultPage from '../pages/crewVault/CrewVault'
import NewCrewVault from '../pages/crewVault/NewCrewVault'
import CrewVaultSingle from '../pages/crewVault/Single/CrewVaultSingle'

export default [
  { path: '/crewvault', element: <CrewVaultPage />, title: 'Crew Vault' },
  { path: '/crewvault/add', element: <NewCrewVault />, title: 'Crew Vault' },
  {
    path: '/crewvault/edit/:existingID',
    element: <NewCrewVault editMode={true} />,
    title: 'Crew Vault',
  },
  { path: '/crewvault/:id', element: <CrewVaultSingle />, title: 'Crew Vault' },
]
